export default __webpack_public_path__ + "static/media/Kotodama Logo 25.fed0b869.gif";